import * as api from "@/api/williams/testEvents";
import { getFullPath, routes } from "../../routes";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router";

export function useDeleteTestEvent(redirect: boolean) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(async (id: string) => {
    await api.deleteTestEvent(id);

    queryClient.removeQueries(queryKeys.testEvent.single(id));
    queryClient.invalidateQueries(queryKeys.testEvent.list());

    if (redirect) {
      navigate(getFullPath(routes.testEvent.list), {
        replace: true,
        state: {
          skipSavePrompt: true,
        },
      });
    }
  });
}
